import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect } from 'react';
import { t } from "i18next";
import Form from 'react-bootstrap/Form';

import { useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyDynamicDropDown(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);
    const [dropdownData, setDropdownData] = useState(question.optionList);

    const [selectedValue, setSelectedValue] = useState(-1);
    const [selectedOption, setSelectedOption] = useState(null);
    const [remark, setRemark] = useState('');

    const handleChange = (event) => {
        const newValue = event.target.value; // Get the selected value directly
        setSelectedValue(newValue); // Set the selected value in the state

        const option = question.optionList.find((option) => option.id == newValue?.id);
        setSelectedOption(option);

        var payload = {
            id: question.id
        };

        if(newValue?.id && newValue.id > 0){
            payload = {
                id: question.id,
                answerList: [{
                    dynamicOptionId: newValue.dynamicOptionId,
                    questionOptionId: newValue.id,
                    answerDescription: newValue.name,
                    remark: newValue.showRemark ? remark : ''
                }]
            };
        }

        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };

    const handleRemarkChange = (event) => {
        setRemark(event.target.value);
        
        var payload = {
            id: question.id,
            answerList: [{
                dynamicOptionId: selectedOption.dynamicOptionId,
                questionOptionId: selectedOption.id,
                answerDescription: selectedOption.name,
                remark: selectedOption.showRemark ? remark : ''
            }]
        };
        
        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };

    return (
        <div>
            <FormControl>
                <Select
                    labelId="Select-single-dynamic"
                    id={"question-id-" + question.id + "-option-id-0"}
                    className={"question-id-" + question.id + "-option-id-0"}
                    name={"questionList[" + question.questionSequenceNo + "].answerList[0].questionOptionId"}
                    value={selectedValue}
                    onChange={handleChange}
                >
                    <MenuItem value={"-1"}>Please Choose</MenuItem>
                    {dropdownData.map((option) => (
                        <MenuItem key={option.id} value={option}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
                
            {selectedOption && selectedOption.showRemark && (
                <Form.Control as="textarea"
                    id={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
                    className={"question-id-" + question.id + "-option-id-" + selectedOption.id + ".remark"}
                    name={"questionList[" + question.questionSequenceNo + "].answerList[" + selectedOption.optionSequenceNo + "].remark"}
                    placeholder="Remark"
                    variant="outlined"
                    value={remark}
                    onChange={handleRemarkChange}
                />
            )}
        </div>
    );
}
